(function () {
  'use strict';

  function getCustomButton() {
    return document.querySelector('.js_custom__btn_wishlist');
  }

  function getPlaceholder() {
    return document.querySelector('.gw-wl-add-to-wishlist-placeholder');
  }

  function getGrowaveButton() {
    const placeholder = getPlaceholder();
    if (!placeholder) return null;

    // Shadow DOM safe
    return placeholder.shadowRoot
      ? placeholder.shadowRoot.querySelector('button.gw-btn')
      : placeholder.querySelector('button.gw-btn');
  }

  /**
   * Синхронизация состояния кастомной кнопки с Growave
   */
  function syncStateFromGrowave() {
    const customBtn = getCustomButton();
    const gwBtn = getGrowaveButton();
    if (!customBtn || !gwBtn) return;

    const inWishlist = gwBtn.getAttribute('data-in-wishlist') === 'true';
    customBtn.classList.toggle('is-active', inWishlist);
  }

  /**
   * Клик по кастомной кнопке
   * Мгновенный UI + триггер Growave
   */
  function bindClick() {
    document.addEventListener('click', function (e) {
      const customBtn = e.target.closest('.js_custom__btn_wishlist');
      if (!customBtn) return;

      e.preventDefault();

      // Optimistic UI
      customBtn.classList.toggle('is-active');

      const gwBtn = getGrowaveButton();
      if (gwBtn) gwBtn.click();
    });
  }

  /**
   * Initial sync с polling
   */
  function initialSyncWithPolling() {
    const maxAttempts = 50; // 50 * 100ms = 5 секунд
    let attempts = 0;

    const interval = setInterval(function () {
      attempts++;
      const gwBtn = getGrowaveButton();

      if (gwBtn && gwBtn.hasAttribute('data-in-wishlist')) {
        syncStateFromGrowave();
        clearInterval(interval);
        return;
      }

      if (attempts >= maxAttempts) {
        clearInterval(interval);
      }
    }, 3000);
  }

  function init() {
    bindClick();
    initialSyncWithPolling();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

(function() {
  function getCustomCardButtons() {
    return document.querySelectorAll('.js_custom__btn_wishlist_card');
  }

  function getGrowaveButtonForCard(customBtn) {
    const placeholder = customBtn.closest('.card__media')?.querySelector('.gw-wl-add-to-wishlist-placeholder');
    if (!placeholder) return null;
    return placeholder.shadowRoot
      ? placeholder.shadowRoot.querySelector('button.gw-btn')
      : placeholder.querySelector('button.gw-btn');
  }

  function syncState(customBtn) {
    const gwBtn = getGrowaveButtonForCard(customBtn);
    if (!gwBtn) return;
    const inWishlist = gwBtn.getAttribute('data-in-wishlist') === 'true';
    customBtn.classList.toggle('is-active', inWishlist);
  }

  function bindClicks() {
    document.addEventListener('click', function(e) {
      const customBtn = e.target.closest('.js_custom__btn_wishlist_card');
      if (!customBtn) return;
      e.preventDefault();

      // UI на кастомной кнопке
      customBtn.classList.toggle('is-active');

      // Триггер кнопки Growave
      const gwBtn = getGrowaveButtonForCard(customBtn);
      if (gwBtn) gwBtn.click();
    });
  }

  function initPolling() {
    const maxAttempts = 50;
    let attempts = 0;
    const interval = setInterval(() => {
      attempts++;
      getCustomCardButtons().forEach(syncState);
      if (attempts >= maxAttempts) clearInterval(interval);
    }, 100);
  }

  function init() {
    bindClicks();
    initPolling();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

